<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="large"
  color="#64d6e2"
  type="ball-clip-rotate-multiple"
  [fullScreen]="true"
  [showSpinner]="isLoading"
  ><p style="color: white">Loading...</p></ngx-spinner
>
